import { IBreadCrumbItem } from 'components/BreadCrumb/BreadCrumbItem';
import PrivateContainer from 'components/PrivateContainer/PrivateContainer';
import { MainRoutePath } from 'library/Routes';
import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Context from './Context';

export default function () {
  const { t } = useTranslation();
  const {
    currentEvent: evento,
  } = useContext(Context);

  const breadCrumb = useMemo<IBreadCrumbItem[]>(
    () => [
      {
        nome: t('MainRoute.title'),
        url: MainRoutePath,
      },
      {
        nome: t('AssembleiaAssociadoRoute.title'),
      },
      {
        nome: evento!.titulo,
      },
    ],
    [t, evento]
  );

  return (
    <PrivateContainer
      title={evento!.titulo}
      subtitle={t('AssembleiaAssociadoRoute.subtitlePre')}
      breadCrumb={breadCrumb}
    >
      {null}
    </PrivateContainer>
  );
}
